import Store from "../store";

export function openSideBar() {
    return {
        type: 'OPEN_SIDEBAR',
        payload: {open: true}
    }
}
export function stopBackgroundScroll() {}
export function closeSideBar() {
    return {
        type: 'CLOSE_SIDEBAR',
        payload: {open: false}
    }
}

export function currentStateChange(page) {
    return {
        type: 'CURRENT_STATE_CHANGE',
        payload: {state: page}
    }
}
